"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IF = void 0;
exports.IF = {
    alias: 'SE',
    description: 'permite fazer uma comparação lógica e escolher um valor caso TRUE, e outro caso FALSE',
    arg_names: ['condição', 'retorno_se_verdadeiro', 'retorno_se_falso'],
    args_description: [
        'condição lógica',
        'retorno caso a condição seja verdadeira',
        'retorno caso a condição seja falsa',
    ],
    replacements: [
        {
            TRUE: 'VERDADEIRO',
            FALSE: 'FALSO',
        },
        null,
        null,
    ],
};
